//"use client"
import { styled } from "@phntms/css-components";
import {motion} from "framer-motion";
import styles from "./styles.module.scss";

export const ModalContainer = styled(motion.div, {
  css: [styles.modal, 'modal'],
  variants: {
    type: {
      'full': [styles.cover, 'modal-full'],
      'popup': [styles.popup, 'modal-cover'],
      'panel': [styles.panel, 'modal-panel']
    },
    appear: {
      dropIn: [styles.dropIn],
      fade: [styles.fade],
      fromBottom: [styles.fromBottom],
      fromRight: [styles.fromRight],

    },
    theme: {
       light: [styles.light],
       dark: [styles.dark],
    },
    backgroundLogo: {
      true: ['background-logo']
    }
  }
})

export const ModalContent = styled('div', {
  css: [styles.content, 'modal-content'],
});
